// MediaKit related text constants to avoid duplication across components

export const MEDIA_KIT_TEXTS = {
  // Tooltip texts for primary/default kit badges
  PRIMARY_KIT_TOOLTIP:
    'This is the primary kit shown on rosters, lists and embeds.',
  DEFAULT_KIT_TOOLTIP:
    'This is the default kit shown on rosters, lists, and embeds.',

  // Badge text labels
  PRIMARY_BADGE_TEXT: 'Primary',
  DEFAULT_BADGE_TEXT: 'Default',

  // Full badge text labels for media kit sidebars
  PRIMARY: 'Primary Media Kit',
  DEFAULT: 'Default Media Kit',

  // Delete tooltip texts
  PRIMARY_DELETE:
    "The primary kit can't be removed - it's shown on rosters, lists and embeds.",
  DEFAULT_DELETE:
    "The default kit can't be removed — it's linked to rosters, lists, and embeds.",
} as const;
